var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import pubsub from "@viewlift/pubsub";
import { useNavigate } from "react-router-dom";
import { iconsToShow } from "../navigation/iconsToShow";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from 'swiper';
SwiperCore.use([Navigation]);
import Item from './Item';
import './index.scss';
import "swiper/css";
import SliderArrows from '../../../components/sliderCore/SliderArrows';
function index(_a) {
    var navigationFonts = _a.navigationFonts;
    var prevNavRef = useRef(null);
    var nextNavRef = useRef(null);
    var _b = __read(useState(null), 2), menu = _b[0], setMenu = _b[1];
    var navigate = useNavigate();
    var getIcon = function (item) {
        if ((item.icon).toLowerCase().includes("http://") || (item.icon).toLowerCase().includes("https://")) {
            return (React.createElement("img", { className: "dropdown-icon-main", src: item.icon, alt: item.title }));
        }
        else if ((item.icon).toLowerCase().includes("icon-")) {
            return (React.createElement("span", { className: "menu-icons" }, iconsToShow(item, (window.location.pathname === item.url), item.url)));
        }
        return '';
    };
    var handleMenu = function (data) {
        if (Object.keys(data).length > 0)
            setMenu(data);
        else
            setMenu(null);
    };
    useEffect(function () {
        pubsub.subscribe('ActiveThumbnailTab', handleMenu);
    }, []);
    return (React.createElement("div", { className: 'thumbnailTrayContainer', style: __assign({}, navigationFonts) },
        React.createElement("div", { ref: prevNavRef },
            React.createElement(SliderArrows, { to: "prev", onClick: function () { return console.log("last"); }, className: "sliderArrow left", isArticlePage: false })),
        menu ? React.createElement(Swiper, { slidesPerView: 5, spaceBetween: 20, navigation: {
                prevEl: prevNavRef.current,
                nextEl: nextNavRef.current,
            }, onInit: function (swiper) {
                swiper.params.navigation.prevEl = prevNavRef.current;
                swiper.params.navigation.nextEl = nextNavRef.current;
                swiper.navigation.init(); // throws error here, navigation is undefined
                swiper.navigation.update();
            }, className: "mySwiper thumnailSwiper", keyboard: {
                enabled: true,
            }, slidesPerGroup: 5, breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 20
                },
                1024: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 20
                },
                1440: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    spaceBetween: 20
                },
            } }, (menu === null || menu === void 0 ? void 0 : menu.items) ? menu === null || menu === void 0 ? void 0 : menu.items.map(function (slide, index) {
            return (React.createElement(SwiperSlide, null,
                React.createElement(Item, { slide: slide })));
        }) : React.createElement(React.Fragment, null)) : React.createElement(React.Fragment, null),
        React.createElement("div", { ref: nextNavRef },
            React.createElement(SliderArrows, { to: "next", onClick: function () { return console.log("first"); }, className: "sliderArrow right", isArticlePage: false }))));
}
export default index;
